import { dateFnsFormat } from '@/helpers/dateFns';
import BaseModel from '../base';
import { localeFormatDefault } from '@/plugins/date-print';

export default class InfoStage extends BaseModel {
  constructor(stage = {}, url) {
    super(stage, url);

    this.description = stage.description || '';
    this.start_at = localeFormatDefault(stage.start_at);
    this.end_at = localeFormatDefault(stage.end_at);
  }

  get dates() {
    const { start_at, end_at } = this;
    const { readableDate } = dateFnsFormat;
    return [
      readableDate(start_at),
      readableDate(end_at),
    ].join(' - ');
  }
}
